import EditEmailToggle from './EditEmailToggle';

export default EditEmailToggle;
